import PropTypes from 'prop-types';

export const EmergencyStatusReport = PropTypes.shape({
  status: PropTypes.bool.isRequired,
  username: PropTypes.string,
  timestamp: PropTypes.string,
});

export default EmergencyStatusReport;
